export default "__VITE_ASSET__DdikHfZw__"